export function chatReducer(state, action) {
  switch (action.type) {
    case "UPDATE_STATE": {
      let conversations = action.payload;
      let rooms = conversations.map((c) => c.conversationId);

      return {
        ...state,
        rooms,
        conversations,
        selectedChat: conversations.length > 0 ? conversations[0] : null,
      };
    }

    case "CHANGE_CHAT": {
      
      return { ...state, selectedChat: action.payload };
    }

    case "SET_USER_STATUS": {
      let { userId, status } = action.payload;
      return {
        ...state,
        usersStatus: { ...state.usersStatus, [userId]: status },
      };
    }
    
    case "SHOW_DOCTORS_LIST": {
      return {
        ...state,
        docList: !state.docList
      };
    }
    
    case "SET_USERS_CURRENT_STATUS": {
      let status = action.payload;
      let usersStatus = { ...state.usersStatus };
      for (let [userId, s] of Object.entries(status)) {
        usersStatus[userId] = s;
      }
      return { ...state, usersStatus };
    }
    
    case "WRITING": {
      if(!action.payload) return { ...state, writing: null }
      let {chatId, userId} = action.payload
      return { ...state, writing: { chatId, userId } };
    }

    case "NEW_CONVERSATION": {
      let newConversation = action.payload;
      let { conversations, rooms, selectedChat } = state;
      selectedChat = selectedChat||newConversation;

      return {
        ...state,
        conversations: [newConversation].concat(conversations),
        rooms: [newConversation.conversationId].concat(rooms),
        selectedChat
      };
    }

    case "NEW_MESSAGE": {
      // If we have a messages array in state, add to it
      if (state.messages) {
        return {
          ...state,
          messages: [...state.messages, action.payload],
          writing: null,
        };
      }
      
      // Original logic for conversations
      let index = state.conversations.findIndex(
        (c) => c.conversationId === action.payload.conversationId
      );

      if (index !== -1) {
        let conversation = state.conversations[index];
        let messages = conversation.messages;

        let selectedChat =
          state.selectedChat.conversationId === action.payload.conversationId
            ? { ...conversation, messages: messages.concat(action.payload) }
            : state.selectedChat;
        return {
          ...state,
          conversations: [
            ...state.conversations.slice(0, index),
            { ...conversation, messages: messages.concat(action.payload) },
            ...state.conversations.slice(index + 1),
          ],
          selectedChat,
          writing: null,
        };
      }

      return state;
    }
    
    case "SET_LOADING": {
      return {
        ...state,
        loading: action.payload
      };
    }
    
    case "SET_SELECTED_CHAT": {
      return {
        ...state,
        selectedChat: action.payload
      };
    }
    
    case "SET_MESSAGES": {
      return {
        ...state,
        messages: action.payload || []
      };
    }
    
    case "DELETE_MESSAGE":
    case "MESSAGE_DELETED": {
      const { messageId, conversationId } = action.payload;
      
      // Update messages array if exists
      if (state.messages) {
        const updatedMessages = state.messages.map(msg => {
          if (msg.messageId === messageId) {
            return {
              ...msg,
              message: "Message deleted",
              isDeleted: true,
              attachment: null
            };
          }
          return msg;
        });
        
        return {
          ...state,
          messages: updatedMessages
        };
      }
      
      // Also update conversations if needed
      const updatedConversations = state.conversations.map(conv => {
        if (conv.conversationId === conversationId && conv.messages) {
          const updatedConvMessages = conv.messages.map(msg => {
            if (msg.messageId === messageId) {
              return {
                ...msg,
                message: "Message deleted",
                isDeleted: true,
                attachment: null
              };
            }
            return msg;
          });
          
          return {
            ...conv,
            messages: updatedConvMessages
          };
        }
        return conv;
      });
      
      // Update selectedChat if it's the affected conversation
      let updatedSelectedChat = state.selectedChat;
      if (state.selectedChat?.conversationId === conversationId && state.selectedChat.messages) {
        updatedSelectedChat = {
          ...state.selectedChat,
          messages: state.selectedChat.messages.map(msg => {
            if (msg.messageId === messageId) {
              return {
                ...msg,
                message: "Message deleted",
                isDeleted: true,
                attachment: null
              };
            }
            return msg;
          })
        };
      }
      
      return {
        ...state,
        conversations: updatedConversations,
        selectedChat: updatedSelectedChat
      };
    }

    default:
      return state;
  }
}

export const initialChatState = {
  conversations: [],
  rooms: [],
  selectedChat: null,
  chatsMap: {},
  usersStatus: {},
  writing: null,
  messages: [],
  loading: false,
};
